var FormEvents = {
    FORM_START: 'form_start',
    QUOTE_COMPLETE: 'quote_complete',
    FORM_STEP_BACK: 'form_step_back',
    EMAIL_QUOTE: 'email_quote',
    FORM_STEP_COMPLETE: 'form_step_complete',
    PURCHASE: 'purchase',
    FULL_QUOTE_COMPLETE: 'full_quote_complete',
    NUMBER_PLANS_RETURNED: 'number_plans_returned',
    SNAP_AND_SEND_SUBMIT: 'snap_send_submit',
};

var FormStepTypes = {
    START: 'start',
    COMPLETE: 'complete',
    GET_QUOTE: 'get_quote',
    QUOTE_REVIEW: 'quote_review',
    GET_FULL_QUOTE: 'get_full_quote',
    FULL_QUOTE_REVIEW: 'full_quote_review',
    PREFERENCES: 'preferences',
    PEOPLE: 'people',
    DETAILS: 'details',
    CHECKOUT: 'checkout',
    CLAIM_SEND: 'claim_send',
    ADD_ONS: 'add_ons',
    SUBMIT: 'submit'
};

module.exports = {
    FormEvents: FormEvents,
    FormStepTypes: FormStepTypes,
};


//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/modules/utils/events.js
// module id = yq58
// module chunks = 0 1 2 3 5 6 9 10 11 12 13 14